module.exports = __webpack_public_path__ + "img/domotica.db83def3.svg";